import {
  ISoccerMatchCardEvent,
  ISoccerMatchGoalEventWithCount,
} from "../../../../types";

type CardEventType = {
  event: ISoccerMatchCardEvent | ISoccerMatchGoalEventWithCount;
  iconSize?: number;
  showTime?: boolean;
  wrapperClassName?: string;
  timeClassName?: string;
};

const cardTypeMap = {
  RC: {
    imgUrl: "/images/match-events/red-card.svg",
    type: "red card",
  },
  YC: {
    imgUrl: "/images/match-events/yellow-card.svg",
    type: "yellow card",
  },
  Y2C: {
    imgUrl: "/images/match-events/second-yellow-card.svg",
    type: "second yellow card",
  },
};

export function GlobalCardEvent({
  event,
  iconSize = 16,
  showTime = false,
  wrapperClassName = "",
  timeClassName = "",
}: CardEventType) {
  const cardType = cardTypeMap[event.type as keyof typeof cardTypeMap] || { imgUrl: "", type: "" };

  return (
    <div className={wrapperClassName}>
      <img
        src={cardType.imgUrl}
        height={iconSize}
        width={iconSize}
        alt={cardType.type}
      />
      {showTime && (
        <span className={timeClassName}>{`${event?.timeMin}'`}</span>
      )}
    </div>
  );
}
